import { GetterTree } from "vuex";
import { AntaresStateInterface } from "./models/AntaresState.interface";
import { antaresStoreTypes } from "./types";

export const getters: GetterTree<AntaresStateInterface, AntaresStateInterface> = {
  [antaresStoreTypes.getters.isLoading]: (state: AntaresStateInterface): boolean => {
    return state.loading;
  },
};
